module.exports = __webpack_public_path__ + "static/media/DigiPraat_Thumbnail.6ea644a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/DigiPraat_Thumbnail.jpg
// module id = 818
// module chunks = 3